module.exports = __webpack_public_path__ + "static/media/air_conditioning.e67db45f.svg";